import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import './Navbar.css';

const Navbar = ({ onMenuToggle }) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        {/* Hamburger — only visible on mobile */}
        <button
          className="navbar-hamburger"
          onClick={onMenuToggle}
          aria-label="Open navigation menu"
        >
          <span />
          <span />
          <span />
        </button>
        <h1>Himlayan</h1>
      </div>
      <div className="navbar-actions">
        <div className="navbar-user">
          <span className="user-name">{user?.name}</span>
          <span className="user-role">({user?.role})</span>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
